import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { CardHistoryTask } from "../../../../components/CardHistoryTask";
import { HeaderTitle } from "../../../../components/HeaderTitle";
import { useTranslate } from "../../../../hooks/useTranslate";
import { loadTaskById } from "../../../../services/tasks";
import { ITask } from "../../interface";

import { Container, Content } from "./styles";

const HistoryTask = () => {
  const params = useParams();
  const { translate } = useTranslate();

  const [task, setTask] = useState<ITask>({} as ITask);

  useEffect(() => {
    if (params.id)
      loadTaskById(params.id).then((response) => {
        setTask(response);
      });
  }, [params]);

  return (
    <Container>
      <HeaderTitle
        title={translate("tasks.title_history")}
        url="/tasks"
        showIcon
      />
      <Content>
        {Object.keys(task).length > 0 && <CardHistoryTask {...task} />}
      </Content>
    </Container>
  );
};

export { HistoryTask };
